import schema from './schemaVersions/v3.js';
	const finalSchema = { wip: false, ...schema };
	export default finalSchema;